export const EP_ADMIN_ORPHANED_COMPANIES = {
  path: "companyRecovery/admin/orphaned",
  method: "GET",
};

export const EP_ADMIN_INVITE_ALL = {
  path: "companyRecovery/admin/inviteAll",
  method: "POST",
};

export const EP_ADMIN_RESEND = {
  path: "companyRecovery/admin/resend",
  method: "POST",
  requestBody: {
    companyId: "",
  },
};

export const EP_CLAIM_INFO = {
  path: "companyRecovery/public/claimInfo",
  method: "GET",
  params: {
    token: "",
  },
};

export const EP_SUBMIT_CLAIM = {
  path: "companyRecovery/public/claim",
  method: "POST",
  requestBody: {
    token: "",
    account: { name: "", surname: "", password: "", userType: 1 },
    company: {
      name: "",
      description: "",
      vat: "",
      address: null,
      logo: null,
      pictures: [],
      phone: "",
      values: "",
      website: "",
      companyType: 1,
    },
  },
};

export const EP_REQUEST_NEW_LINK = {
  path: "companyRecovery/public/requestNewLink",
  method: "POST",
  requestBody: {
    email: "",
  },
};
